import {
  FETCH_RECOS,
  RECEIVE_RECOS
} from 'constants/reduxActions';
import { evRecommendationImpressionWrapper } from 'events/recommendations';
import { getJanusRecos } from 'apis/mafia';
import marketplace from 'cfg/marketplace.json';
import recommenderFilterFormatter from 'helpers/recommenderFilterFormatter';
import { buildProductPageRecoKey, buildRecosKey, buildRequestSlots, getRecosSlot, parseRecommenderFilterValue } from 'helpers/RecoUtils';
import ProductUtils from 'helpers/ProductUtils';
import { track } from 'apis/amethyst';

const {
  api: {
    mafia
  },
  pdp: { recos: productRecoSlots },
  recos: { slots }
} = marketplace;

const DEFAULT_NUMBER_OF_RECOS = 5;

export function fetchingRecos() {
  return {
    type: FETCH_RECOS
  };
}

export function receiveRecos(key, data, imageHost) {
  return {
    type: RECEIVE_RECOS,
    data,
    key,
    imageHost
  };
}

function getImageHost(state) {
  const {
    environmentConfig: {
      imageServer: {
        url: imageHost
      }
    }
  } = state;
  return imageHost;
}
export function fetchRecos(slotDetails, janusFetcher = getJanusRecos) {
  const { filters = [], limit, widget } = slotDetails;
  const parsedFilters = {};
  filters.forEach(f => {
    parsedFilters[f.name] = parseRecommenderFilterValue(f.value);
  });

  const janusFilter = recommenderFilterFormatter(parsedFilters).setState();
  // Apply custom widget parameter if declared
  const nameList = widget || janusFilter.getRecommenderName();
  const { filterString } = janusFilter;
  const recommenderNames = Array.isArray(nameList) ? nameList.join(',') : nameList;
  return (dispatch, getState) => {
    const state = getState();
    const { cookies = {} } = state;

    const paramObj = { params: { filter: filterString }, widgets: recommenderNames, limit: limit || DEFAULT_NUMBER_OF_RECOS, credentials: cookies, dispatch, getState };

    return janusFetcher(mafia, paramObj)
      .then((resp = {}) => {
        Promise.all(Object.keys(resp).map(recoName => {
          dispatch(receiveRecos(buildRecosKey(slotDetails, recoName),
            { [recoName]: resp[recoName] }, getImageHost(state)));
        }));
      });
  };
}

export function fetchProductPageRecos(productId, styleId, isVisualRecos = false, isExternalRequest = false, janusFetcher = getJanusRecos) {
  return (dispatch, getState) => {
    const state = getState();

    const { cookies } = state;

    let params = { item: productId };
    if (styleId) {
      params.teen = styleId;
    }
    const shouldLoadDetail0Slot = slots.hasOwnProperty('detail-0');
    const { limits, widgets } = buildRequestSlots(isVisualRecos, isExternalRequest, shouldLoadDetail0Slot);
    params = { ...params, ...limits };
    const recoKey = buildProductPageRecoKey(productId, styleId);
    dispatch(fetchingRecos());

    return janusFetcher(mafia, { params, widgets, limit: DEFAULT_NUMBER_OF_RECOS, credentials: cookies, dispatch, getState })
      .then(resp => {
        dispatch(receiveRecos(recoKey, resp, getImageHost(state)));
        if (resp) {
          Object.keys(productRecoSlots).forEach(slot => {
            const shownReco = getRecosSlot(resp, slot);
            if (shownReco) {
              const recommendationImpression = [{
                numberOfRecommendations: shownReco.sims.length,
                recommendationType: 'PRODUCT_RECOMMENDATION',
                recommendationSource: 'EP13N',
                widgetType: ProductUtils.translateRecoTitleToAmethystWidget(shownReco.title)
              }];

              track(() => ([evRecommendationImpressionWrapper, { recommendationImpression }]));
            }
          });
        }
      });
  };
}

/**
 * Used to fetch a single slot for a product and style.  Data is stored in the state under the requested slot name.
 * @param {Object} options
 * @param {String} options.productId
 * @param {String} options.styleId
 * @param {String} options.slot the slot to request.
 * @param {Number} options.limit number
 * @param {function} [options.janusFetcher] api function for fetching recos
 * @param {String} [options.storageKey] optional string for where to store results under. Default to the requested slot name.
 */
export function fetchProductRecos({
  productId,
  styleId,
  slot,
  limit,
  janusFetcher = getJanusRecos,
  storageKey
}) {
  return (dispatch, getState) => {
    const state = getState();
    const { cookies } = state;

    dispatch(fetchingRecos());
    return janusFetcher(mafia, { params: { item: productId, limit, teen: styleId }, widgets: slot, limit, credentials: cookies, dispatch, getState })
      .then(resp => {
        dispatch(receiveRecos(storageKey || slot, resp, getImageHost(state)));
      });
  };
}
